import { Badge } from "@mantine/core";
import type { PlatformInvoiceStatus } from "../../apis/platformInvoice";

const COLOR: Record<PlatformInvoiceStatus, string> = {
  DRAFT        : "gray",
  ISSUED       : "blue",
  SENT         : "cyan",
  PARTIALLY_PAID: "yellow",
  PAID         : "green",
  OVERDUE      : "red",
  VOID         : "dark",
};

const LABEL: Record<PlatformInvoiceStatus, string> = {
  DRAFT        : "Ноорог",
  ISSUED       : "Гаргасан",
  SENT         : "Илгээсэн",
  PARTIALLY_PAID: "Хэсэгчлэн төлсөн",
  PAID         : "Төлсөн",
  OVERDUE      : "Хугацаа хэтэрсэн",
  VOID         : "Хүчингүй",
};

export function InvoiceStatusBadge({ status }: { status: PlatformInvoiceStatus }) {
  return <Badge color={COLOR[status]} variant="light">{LABEL[status]}</Badge>;
}
